import React from 'react';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { ConceptsOverview } from './components/ConceptsOverview';
import { ConceptDeepDive } from './components/ConceptDeepDive';
import { Manifesto } from './components/Manifesto';
import { GettingStarted } from './components/GettingStarted';
import { PlatformTeaser } from './components/PlatformTeaser';
import { WaitlistForm } from './components/WaitlistForm';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-background font-sans text-foreground antialiased selection:bg-indigo-100 selection:text-indigo-900" data-id="element-0">
      <Navigation data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <ConceptsOverview data-id="element-4" />
        <ConceptDeepDive data-id="element-5" />
        <Manifesto data-id="element-6" />
        <GettingStarted data-id="element-7" />
        <PlatformTeaser data-id="element-8" />
        <WaitlistForm data-id="element-9" />
      </main>

      <Footer data-id="element-10" />
    </div>;
}